const pattern = /_(\d+\.\d+\.\d+(?:-\S+)?)[.-]\d+\.\S+/;

export const getInstallerVersion = (path: string): string | null => {
  const match = path.match(pattern);
  if (match) return match[1];
  return null;
};
